import { ProfileState, PasswordResponseProps } from './types';
import { createSlice } from '@reduxjs/toolkit';
import {
  updatePasswordUser,
  updatePasswordMerchant,
} from './profile.store.services';

export const initialState: ProfileState = {
  data: {} as PasswordResponseProps,
  status: 'loading',
  error: {},
};

export const ProfileSlice = createSlice({
  name: 'productStore',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updatePasswordUser.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updatePasswordUser.fulfilled, (state, action) => {
        if (action.payload) {
          state.data = action.payload.data;
          state.status = action.payload.status;
          state.error = action.payload.error;
        }
      })
      .addCase(updatePasswordUser.rejected, (state, action) => {
        state.status = 'error';
        state.error = action.error;
      });
  },
});

export const ProfileReducer = ProfileSlice.reducer;
